import { useTranslation } from 'react-i18next'
import { pageTitle } from '@/lib/form-styles'
import { CustomGroupsTab } from './SelectionDataPage'

/** Einzelseite „Zusatzfeld-Gruppen" (Vorgabedatensätze gruppierter Felder). */
export default function GruppenPage() {
  const { t } = useTranslation()
  return (
    <div className="space-y-4 p-4 sm:p-6">
      <h1 className={pageTitle}>Zusatzfeld-Gruppen</h1>
      <CustomGroupsTab t={t} />
    </div>
  )
}
